module.exports = __webpack_public_path__ + "img/napas.7590dd65.png";